import $ from "cash-dom";
import {mapComponent} from "./map/component";
import {submissionsChartComponent} from "./index/submissions-chart";
import {submissionsLineChartComponent} from "./index/submissions-line-chart";
import {toggleBodyComponent} from "./news/toggle-body";
import {countdownComponent} from "./countdown/countdown";

$(document).ready(() => {
    mapComponent('#map-centers');
    countdownComponent();
    const chart = submissionsChartComponent();
    //const lineChart = submissionsLineChartComponent();

    const $bigVideo = $(".video-big");
    const $smallVideo = $(".video-small");

    $smallVideo.each(() => {
        $smallVideo.css("height", ($smallVideo.width() / 1.78).toString());
    });

    $bigVideo.each(() => {
        $bigVideo.css("height", ($bigVideo.width() / 1.78).toString())
    });

    toggleBodyComponent('.articles');

    $(window).on('resize', (e) => {
        $smallVideo.each(() => {
            $smallVideo.css("height", ($smallVideo.width() / 1.78).toString())
        });

        $bigVideo.each(() => {
            $bigVideo.css("height", ($bigVideo.width() / 1.78).toString())
        });

        chart.onResize(e);
        //lineChart.onResize(e);
        $bigVideo.css("height", ($bigVideo.width() / 1.78).toString())
    });
});
